import React, { useEffect, useState } from 'react'
import MainTitle from '../common/MainTitle'
import CustomHr from '../common/CustomHr'
import SimpleChart from '../statistics/SimpleChart'
import { H3 } from '@blueprintjs/core'
import { translate } from 'utlis/translations/i18n'


const ClosedFeedback = ({ feedback, selectedName }) => {

    const [FeedbackData, setFeedbackData] = useState([]);
    //Si l'utilisteur n'a pas répondu à la question, sa réponsé sera une string par défault.
    //Nous utilisons un filtre dans le useEffect pour ne pas prendre en compte les réponses qui ne sont pas des numbers
    //Ici, nous créons un state qui va contenir la moyenne des réponses indéxées sur le nouveau tableau de réponses filtrées
    const [averageScore, setAverageScore] = useState(0);

    useEffect(() => {
        // Filtrer uniquement les réponses numériques valides
        const validNumericAnswers = feedback.answers.filter(answer => {
            const answerNum = parseInt(answer.answer, 10);
            return !isNaN(answerNum) && answerNum >= 1 && answerNum <= 10;
        });

        // Calcul de la moyenne
        const total = validNumericAnswers.reduce((acc, curr) => acc + parseInt(curr.answer, 10), 0);
        const average = validNumericAnswers.length > 0 ? (total / validNumericAnswers.length) : 0;
        setAverageScore(average.toFixed(2));

        // Filtrer les réponses par nom si un nom est sélectionné
        const filteredAnswers = validNumericAnswers.filter(answer => !selectedName || answer.participantName === selectedName);

        // Initialisation des données pour le graphique
        let data = Array.from({ length: 10 }, (_, i) => ({ name: `${i + 1}`, rate: 0 }));

        // Accumulation des votes pour chaque note
        filteredAnswers.forEach(answer => {
            // Convertir la réponse en nombre et décrémenter de 1 pour obtenir l'index
            const index = parseInt(answer.answer, 10) - 1;
            // Ajouter le pourcentage de cette réponse à la note correspondante dans le tableau de données
            data[index].rate = parseFloat(data[index].rate) + (1 / filteredAnswers.length * 100);
        });

        // Pour chaque élément dans le tableau de données
        // Arrondir le taux de chaque note à deux décimales
        data.forEach(item => item.rate = item.rate.toFixed(2));

        setFeedbackData(data);
    }, [feedback, selectedName]);

    return (
        <div>
            <MainTitle text={< span> Feedback: <br />  <br /> {feedback.feedback.question}</span>} />
            <div className="text-center">
                <H3 className="new-results">{translate('average')} <br />{averageScore} / 10</H3>
            </div>
            <SimpleChart
                key={0}
                data={FeedbackData}
                maximum={10}
                value="rate"
                domain={[0, 100]}
                YName={translate('participantsPercentage')}
                XName={translate('scoreOutOf10')}
            />
            <CustomHr />
        </div>
    )
}

export default ClosedFeedback